import {
  BMComponentsType,
  BMPrimitives,
  BMText,
  useBMTheme,
} from "@traveloka/district-bloom";
import { Image, StyleSheet } from "react-native";
import { CALENDAR_ICON } from "../../../../assets/calendar";
import { NEXT_TRIP_BACKGROUND } from "../../../../assets/next-trip/background";
import BMView from "../../../../components/View/BMView";
import { useMobileContentResource } from "../../../../core/resource/MobileResourceProvider";
import { BookingStatus, ProductType } from "../../../../types";
import NextTripTabs from "./NextTripTabs";

export type ProductState<T> = {
  isLoading: boolean;
  isError: boolean;
  reFetchData(): void;
  redirectToSearchForm(): void;
  productData: T | null;
};

export type NextTripFlightData = {
  bookingId: string;
  departureLocation: string;
  arrivalLocation: string;
  departureDate: Date;
  numOfPassenger: number;
  bookingStatus: BookingStatus;
  isRoundTrip: boolean;
};

export type NextTripHotelData = {
  bookingId: string;
  hotelName: string;
  checkInDate: Date;
  checkOutDate: Date;
  numOfGuest: number;
  numOfRoom: number;
  bookingStatus: BookingStatus;
};

export type NextTripTabsType = "FLIGHT" | "HOTEL";

export type MobileHomeNextTripProps = {
  redirectToBookingList(): void;
  redirectToBookingDetail(productType: ProductType, bookingId: string): void;
  data: {
    FLIGHT: ProductState<NextTripFlightData>;
    HOTEL: ProductState<NextTripHotelData>;
  };
};

export default function MobileHomeNextTrip(props: MobileHomeNextTripProps) {
  const { redirectToBookingList } = props;

  const { CorporatePostLogin: cr } = useMobileContentResource();
  const { BMComponents } = useBMTheme();
  const styles = createStyles(BMComponents);

  return (
    <BMView style={styles.container}>
      <BMView
        style={styles.header}
        row
        justify="between"
        align="center"
        spacing="xs"
      >
        <BMView row align="center" spacing="xs">
          <Image style={styles.calendarIcon} source={{ uri: CALENDAR_ICON }} />
          <BMText variant="titleSmall">{cr.nextTripTitle}</BMText>
        </BMView>
        <BMText
          ink="BMStyleTextInkAction"
          variant="uiNormal"
          onPress={redirectToBookingList}
        >
          {cr.seeAllBookingCta}
        </BMText>
      </BMView>
      <NextTripTabs {...props} />
      <Image style={styles.background} source={{ uri: NEXT_TRIP_BACKGROUND }} />
    </BMView>
  );
}

function createStyles(BMComponents: BMComponentsType) {
  return StyleSheet.create({
    container: {
      position: "relative",
      paddingVertical: BMPrimitives.BMSize.lg,
      paddingHorizontal: BMPrimitives.BMSize.md,
      backgroundColor: BMComponents.BMStyleSurfaceBgcolorHighlight,
      overflow: "hidden",
    },
    header: {
      marginBottom: BMPrimitives.BMSize.md,
    },
    calendarIcon: {
      width: 16,
      height: 16,
    },
    background: {
      position: "absolute",
      right: 9,
      top: -6,
      width: 174,
      height: 198,
      zIndex: -1,
    },
  });
}
